/**
 * @param {number} length
 * @return {Array}
 */
export default (function (length) {
  return Array.apply(null, { length: length });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/utils/range.js
// module id = 309
// module chunks = 0